//@ts-nocheck
//@ts-ignore
/* eslint-disable */
import React from 'react';
// import './style.scss';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import Button from 'src/onboarding/components/ui/button';
import { Check } from 'src/onboarding/components/ui/check/Check';
import { Option } from 'src/onboarding/components/ui/check/Option';
import { Title } from 'src/onboarding/components/typography/Title/Title';

function Page() {
  const prepareMeals = useStore((state) => state.prepareMeals);
  const setPrepareMeals = useStore((state) => state.setPrepareMeals);
  const { onNext, onPrev, currentIndex } = useNav();

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.prepareMeals.title')}</Title>
      </div>

      <div className={'controls'}>
        <Check
          defaultValue={prepareMeals}
          onChange={(value) => {
            setPrepareMeals(value);
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'prepare-meals',
              answer: value,
            });
            onNext();
          }}
        >
          <Option value={'home'}>
            <span>🏠</span> {t('onboarding.prepareMeals.options.home')}
          </Option>
          <Option value={'eat out or order'}>
            <span>🍽</span> {t('onboarding.prepareMeals.options.eatOut')}
          </Option>
          <Option value={'a mix of home and eat out'}>
            <span>🌞</span> {t('onboarding.prepareMeals.options.mix')}
          </Option>
        </Check>
      </div>
    </div>
  );
}
export default Page;
